import React from "react";
import { MediaContainer } from "../../ui/mediaContainer/mediaContainer";
import {
	YoutubePlayer,
	youtubeVideo,
	youtubeVideoId
} from "../../providers/youtube/youtube";
import styles from "./bookmarkPage.css";

export const BookmarkPageMedia = ({ url, image }) => {
	if (String(url).match(youtubeVideo)) {
		// If it's a youtube link show the youtube player
		const id = String(url).match(youtubeVideoId)[0];

		return <YoutubePlayer id={id} />;
	} else if (image) {
		// If it has an image, show the image
		return (
			<div className={styles.mediaPrimary}>
				<MediaContainer className={styles.mediaPrimary} image={image} />
			</div>
		);
	}

	return null;
};



// WEBPACK FOOTER //
// ./src/components/pages/bookmarkPage/bookmarkPageMedia.js